/**
 * Ordered list of free VHF scenario IDs (client-safe, no Node fs).
 * Must match the scenarios in free-vhf-config / module JSON files.
 */
export const FREE_VHF_SCENARIO_IDS_CLIENT: readonly string[] = [
  "M1-S01", "M1-S02", "M1-S03", "M1-S04", "M1-S05", "M1-S06", "M1-S07",
  "M2-S01", "M2-S02", "M2-S03", "M2-S04", "M2-S05", "M2-S06", "M2-S07",
  "M3-S01", "M3-S02", "M3-S03", "M3-S04",
];

export const FREE_VHF_TOTAL_LESSONS_CLIENT = FREE_VHF_SCENARIO_IDS_CLIENT.length;
